import GTagHelper from "./GTagHelper";

export default class MapHelper {
    public static mapBox = null;

    private static defaultZoom = 11;
    private static minZoom = 6;
    private static locationZoom = 12;
    private static defaultLongitude = 9.7161957;
    private static defaultLatitude = 45.6626864;

    public static init() {
        this.setMap();
    }

    private static setMap() {
        (<any>window).mapboxgl.accessToken = "pk.eyJ1IjoibWVjdHJvbmljIiwiYSI6ImNrb3R4OGl2YzBmcHUyeXF2Nm94cWZwNWQifQ.e4p5sBY5fuBLfE-i8wCveQ";

        this.setDefaultCoordinates();

        let self = this;
        let center = new (<any>window).mapboxgl.LngLat(this.defaultLongitude, this.defaultLatitude);
        let navigationControl = new (<any>window).mapboxgl.NavigationControl();
        let geolocateControl = new (<any>window).mapboxgl.GeolocateControl({
            positionOptions: {
                enableHighAccurancy: true
            }
        });

        this.mapBox = new (<any>window).mapboxgl.Map({
            container: "Mapbox",
            zoom: this.defaultZoom,
            center: center,
            minZoom: this.minZoom
        });

        this.mapBox.setStyle("mapbox://styles/mapbox/streets-v11");

        this.mapBox.addControl(navigationControl);
        this.mapBox.addControl(geolocateControl);

        this.mapBox.scrollZoom.disable();

        this.mapBox.on("load", function () {
            geolocateControl.trigger();
        });

        this.mapBox.on("geolocate", function () {
            var userlocation = geolocateControl._lastKnownPosition;
            if (userlocation) {
                self.centerMap(new (<any>window).mapboxgl.LngLat(userlocation.coords.longitude, userlocation.coords.latitude));
            }
        });

        var geocoder = new (<any>window).MapboxGeocoder({
            accessToken: (<any>window).mapboxgl.accessToken,
            mapboxgl: (<any>window).mapboxgl,
            types: "region,postcode,district,place,locality,neighborhood,address",
            language: (<any>window).App.bag.language
        });

        document.getElementById("AutocompleteLocation").appendChild(geocoder.onAdd(this.mapBox.map));

        geocoder.on("result", function (e) {
            GTagHelper.sendEvent("view_search_results", "locator", e.result.place_name_it)
            self.mapBox.flyTo({
                center: e.result.center,
                zoom: self.locationZoom,
                duration: 0
            });
        });

        this.mapBox.on("resize", function () {
            self.resizeMap();
        });
    }

    public static setMarker(latitude, longitude, popupContent) {
        return new (<any>window).mapboxgl.Marker().setLngLat([longitude, latitude]).setPopup(new (<any>window).mapBoxGL.Popup().setHTML(popupContent)).addTo(this.mapBox);
    }

    public static centerToUserLocation() {
        this.mapBox.geolocateControl.trigger();

        var userlocation = this.mapBox.geolocateControl._lastKnownPosition;
        if (userlocation) {
            this.centerMap(new (<any>window).mapboxgl.LngLat(userlocation.coords.longitude, userlocation.coords.latitude));
            return true;
        } else {
            return false;
        }
    }

    public static setBounds(markers: any) {
        let northEastLat = null,
            northEastLng = null,
            southWestLat = null,
            southWestLng = null;

        markers.forEach(function (marker) {
            let selectMarker = marker.getLngLat();

            if (northEastLat === null && northEastLng === null) {
                northEastLat = selectMarker.lat;
                northEastLng = selectMarker.lng;
            } else {
                if (selectMarker.lat > northEastLat) {
                    northEastLat = selectMarker.lat;
                }

                if (selectMarker.lng > northEastLng) {
                    northEastLng = selectMarker.lng;
                }
            }

            if (southWestLat === null && southWestLng === null) {
                southWestLat = selectMarker.lat;
                southWestLng = selectMarker.lng;
            } else {
                if (selectMarker.lat < southWestLat) {
                    southWestLat = selectMarker.lat;
                }

                if (selectMarker.lng < southWestLng) {
                    southWestLng = selectMarker.lng;
                }
            }
        });

        let bounds = new (<any>window).mapboxgl.LngLatBounds(new (<any>window).mapboxgl.LngLat(northEastLng, northEastLat), new (<any>window).mapboxgl.LngLat(southWestLng, southWestLat));

        this.mapBox.fitBounds(bounds, {
            padding: { top: 100, bottom: 100, left: 100, right: 100 }
        });
    }

    private static setDefaultCoordinates() {
        this.defaultLongitude = 9.6320702;
        this.defaultLatitude = 45.693237;
    }

    public static centerMap(lnglat) {
        let zoom = this.locationZoom;

        if (!lnglat) {
            lnglat = new (<any>window).mapboxgl.LngLat(this.defaultLongitude, this.defaultLatitude);
            zoom = this.defaultZoom;
        }

        this.mapBox.flyTo({
            center: lnglat,
            zoom: zoom
        });
    }

    private static resizeMap() {
        var center = this.mapBox.getCenter();
        this.mapBox.setCenter(center);
    }
}